import { ActionType, ProColumns } from '@ant-design/pro-components';
import { Form, Input, Tabs } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
// icons
import { ROUTES } from 'base/routes/routes';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import { Filter, Plus } from 'base/ui/components/Icons';
import { cloneDeep } from 'lodash';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { SearchModel } from 'pages/model';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CampaignModel } from 'services/Main/campaign_services';
import { CommonModel } from 'services/Main/common_services';
import { campaignPresenter, campaignStore, commonPresenter, commonStore, uiStore } from 'stores/root_store';
import { PAGE_SIZE_DEFAULT, SYSTEM_TITLE } from 'utils/constants';
import { formatNumber } from 'utils/formatHelper';
import { checkPermission, useCheckPermission } from 'utils/permissionHelper';
import ChartTab from './chartTab';
import usePartialState from 'hooks/usePartialState';
import useDebounce from 'hooks/useDebounce';

// QUẢN LÝ CAMPAIGN
const createCampaignManage = () => {
  return observer(() => {
    // Kiểm tra phân quyền
    useCheckPermission('INDEX');
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.campaign-manage') + ' - ' + SYSTEM_TITLE;

    const [open, setOpen] = useState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });
    const [form] = Form.useForm();

    // ==================================== STATE ===================================================
    // -----DANH SÁCH COMMON ----------------------------------------------

    //--- DATA TABLE ------------------------------------------------------------
    const [dataPaging, setDataPaging] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
      code: undefined,
      name: undefined,
      actived: undefined,
    });
    // data table báo cáo
    const [dataTable, setDataTable] = useState<CampaignModel[]>([]);
    // trạng thái gửi tin
    const [sentStatus, setSentStatus] = useState<CommonModel[]>([]);

    // ============================================================ STATE ==========================================================
    const [campaignState, setCampaignState] = usePartialState({
      loading: false,
    });

    const [listCreateBy, setListCreateBy] = useState<CommonModel[]>([]);

    // Chart doanh số

    // ======================================================== function =================================================================
    // ----CÁC HÀM LẤY DATA -------------------------------------------------------------------

    const getDataCampaignStatus = async () => {
      await commonPresenter.getCommonDataByKey(commonStore, 'CampaignStatus');
      if (commonStore.commonRespone.isSuccess) {
        setSentStatus(commonStore.commonRespone.data);
      }
    };

    const getDataTable = async (dataSearch: any) => {
      await campaignPresenter.getListCampaign(campaignStore, dataSearch);
      if (campaignStore.listCampaign.isSuccess) {
        const dataTemp = cloneDeep(campaignStore.listCampaign.data);
        setDataTable(dataTemp);
        return dataTemp;
      }
      setDataTable([]);
      return [];
    };



    // Lấy  danh sách người tạo
    const getListCreateBy = async (key = '') => {
      await commonPresenter.getListCreateBy(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        setListCreateBy(commonStore.commonRespone.data);
      }
    };
    const searchCreateBy = useDebounce(getListCreateBy, 500);


    // ---------------XỬ LÝ COLUMN VÀ TABLE-----------------------------------------------------------------------------------------------------
    const columns: ProColumns<CampaignModel>[] = [
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        width: 70,
        align: 'center',
      },
      // Mã chiến dịch
      {
        title: t('event.campaign-code'),
        dataIndex: 'campaignCode',
        key: 'campaignCode',
        fixed: 'left',
        width: 100,
        render: (text, record) => <Link to={ROUTES.CAMPAIGN.CAMPAIGN_MANAGE.DETAIL.LINK + record.id}>{text}</Link>,
      },
      // Tên chiến dịch
      {
        title: t('event.campaign-name'),
        dataIndex: 'campaignName',
        key: 'campaignName',
        fixed: 'left',
        render: (text, record) => <Link to={ROUTES.CAMPAIGN.CAMPAIGN_MANAGE.DETAIL.LINK + record.id}>{text}</Link>,
      },
      // // Campaign code
      // {
      //   title: 'Campaign code',
      //   dataIndex: 'contactSegmentationName',
      //   key: 'contactSegmentationName',
      //   width: 100,
      //   render: (text, record) => <Link to={''}>{text}</Link>,
      // },
      // Doanh số
      {
        title: 'Doanh số theo chiến dịch',
        dataIndex: 'revenue',
        key: 'revenue',
        width: 120,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text === '-' ? text : formatNumber(Number(text), 2)),
      },
      // segment
      {
        title: 'Segment',
        dataIndex: 'segment',
        key: 'segment',
      },
      // Thời gian
      {
        title: 'Thời gian',
        dataIndex: 'sendDate',
        key: 'sendDate',
        valueType: 'dateTime',
        fieldProps: {
          format: 'DD/MM/YYYY HH:mm:ss',
        },
        width: 150,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // Phương thức gửi
      {
        title: t('campaign.sent-method'),
        dataIndex: 'sendType',
        key: 'sendType',
        width: 200,
      },
      // Trạng thái
      {
        title: t('campaign.status'),
        dataIndex: 'statusSend',
        key: 'statusSend',
        width: 100,
      },
      // Người tạo
      {
        title: t('campaign.create-by'),
        dataIndex: 'createBy',
        key: 'createBy',
        width: 200,

      },
      //   Ngày tạo
      {
        title: t('campaign.create-date'),
        dataIndex: 'createTime',
        key: 'createTime',
        valueType: 'dateTime',
        fieldProps: {
          format: 'DD/MM/YYYY HH:mm:ss',
        },
        width: 150,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
    ];

    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };

    useEffect(() => {
      getDataCampaignStatus();
      searchCreateBy();
    }, []);

    const tableRef = useRef<ActionType>();

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.campaign-manage'),
          },
        ]}
        extras={
          <>
            {checkPermission('CREATE') && (
              <Link to={ROUTES.CAMPAIGN.CAMPAIGN_MANAGE.CREATE.LINK}>
                <CustomButton type="primary" icon={<Plus className="!fill-white" />}>
                  {t('btn.create')}
                </CustomButton>
              </Link>
            )}
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <Tabs
            size={'small'}
            type="card"
            className={
              'h-full [&_.ant-tabs-tab]:!rounded-t-sm [&_.ant-tabs-tab]:!text-default [&_.ant-tabs-tab]:!font-semibold [&_.ant-tabs-tab:hover]:!text-primary [&_.ant-tabs-tab]:!border-gray-300 [&>.ant-tabs-nav_.ant-tabs-tab]:!bg-gray-200 ' +
              '[&>.ant-tabs-nav_.ant-tabs-tab.ant-tabs-tab-active]:!bg-white [&_.ant-tabs-tab-active]:!border-b-white [&_.ant-tabs-tab-active>div]:!text-primary [&_.ant-tabs-nav]:!mb-0 [&_.ant-tabs-nav::before]:!border-b-gray-300 ' +
              '[&_.ant-tabs-nav-add]:!border [&_.ant-tabs-nav-add]:!border-gray-300 '
            }
            items={[
              {
                label: 'Danh sách',
                key: '1',
                children: (
                  <CustomProTable<CampaignModel>
                    className="mt-3"
                    bordered
                    columns={columns}
                    dataSource={dataTable}
                    handleResize={() => { }}
                    scroll={{ x: 2000 }}
                    actionRef={tableRef}
                    request={async (params = {}, sort, filter) => {
                      const data = await getDataTable({
                        ...dataPaging,
                        paging: {
                          ...dataPaging.paging,
                          orderBy:
                            Object.values(sort)[0] === 'ascend'
                              ? `${Object.keys(sort)[0].split(',').pop()}`
                              : undefined,
                          orderByDesc:
                            Object.values(sort)[0] === 'descend'
                              ? `${Object.keys(sort)[0].split(',').pop()}`
                              : undefined,
                        },
                      });

                      if (Object.values(sort).length) {
                        setDataPaging({
                          ...dataPaging,
                          paging: {
                            ...dataPaging.paging,
                            orderBy:
                              Object.values(sort)[0] === 'ascend'
                                ? `${Object.keys(sort)[0].split(',').pop()}`
                                : undefined,
                            orderByDesc:
                              Object.values(sort)[0] === 'descend'
                                ? `${Object.keys(sort)[0].split(',').pop()}`
                                : undefined,
                          },
                        });
                      }
                      return {
                        data: data,
                        success: campaignStore.listCampaign.isSuccess,
                      };
                    }}

                    toolBarRender={() => [
                      <CustomButton
                        loading={campaignState.loading}
                        onClick={async () => {
                          setCampaignState({ loading: true });
                          const { paging, ...rest } = dataPaging
                          await campaignPresenter.exportExcelCampaign({ ...rest, lang: uiStore.language })
                          setTimeout(() => {
                            setCampaignState({ loading: false });
                          }, 1000);
                        }}
                        icon={<Icon.Download className={'!fill-dark'} />}
                      >
                        {t('btn.export')}
                      </CustomButton>
                    ]}
                    rowKey="stt"
                    pagination={{
                      ...tablePagination(dataPaging, setDataPaging),
                      total: campaignStore.listCampaign.paging?.totalCount,
                    }}
                    options={{
                      setting: false,
                      density: false,
                      fullScreen: false,
                      reload: false,
                    }}
                  />
                ),
              },
              {
                label: 'Biểu đồ',
                key: '2',
                children: <ChartTab />,
              },
            ]}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox
          onClose={onClose}
          className="lg:!w-[25%]"
          open={open.openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              type="primary"
              onClick={() => {
                const code = form.getFieldValue('customerSegmentationCode');

                setDataPaging({
                  ...form.getFieldsValue(),
                  customerSegmentationCode: Number(code) ? Number(code) : undefined,
                  paging: { ...dataPaging.paging, pageIndex: 1 },
                });
                form.submit();
                tableRef.current?.reload();
                onClose();
              }}
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <SearchForm form={form} column="col-1">
            {/* mã chiến dịch */}
            <SearchItem name={'code'} label={t('event.campaign-code')}>
              <Input />
            </SearchItem>
            {/* Tên chiến dịch */}
            <SearchItem name={'name'} label={t('event.campaign-name')}>
              <Input />
            </SearchItem>
            {/* Người tạo */}
            <SearchItem name={'createBy'} label={t('search-form.created-by')}>
              <CustomSelect
                options={listCreateBy}
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={false}
                onSearch={(value) => {
                  searchCreateBy(value);
                }}
                allowClear
                showSearch
              />
            </SearchItem>
            {/* Trạng thái */}
            <SearchItem name={'actived'} label={t('segment.trang-thai')}>
              <CustomSelect options={sentStatus} fieldNames={{ label: 'value', value: 'key' }} allowClear />
            </SearchItem>
          </SearchForm>
        </SearchBox>
      </PageWrapper >
    );
  });
};

export default createCampaignManage;
